import CheckIcon from 'mdi-react/CheckIcon'
import { useDispatch, useSelector } from 'react-redux'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import { getIsCompleted } from '@/ducks/shopOrderReducer'
import {
  getIsStepActive,
  getIsStepFinished,
  getIsStepStarted,
  getRelevantSteps,
  goToStep,
  isStepValid,
} from '@/ducks/shopProgressReducer'

import './progress-bar.scss'

const ProgressBar = () => {
  const { whiteLabel } = useAppContext()

  const steps = useSelector(getRelevantSteps)

  return (
    <div className={`progress-bar wl-${whiteLabel}`}>
      {/* @ts-ignore */}
      {steps.map((step, id) => (
        <Step key={id} id={id} step={step} />
      ))}
    </div>
  )
}

const Step = ({ step, id }: any) => {
  const dispatch = useDispatch()
  const isFinished = useSelector(state => getIsStepFinished(state, id))
  const isOrderCompleted = useSelector(getIsCompleted)
  const isStarted = useSelector(state => getIsStepStarted(state, id))
  const isActive = useSelector(state => getIsStepActive(state, id))
  const isValid = useSelector(state => isStepValid(state, step))

  const onClick = () => isStarted && dispatch(goToStep(id))

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={`step ${isFinished && 'done'} ${isStarted && 'started'} ${isActive && 'active'} ${
        !isValid && isFinished && 'invalid'
      }`}
      onClick={onClick}
    >
      <div className="step-content">
        <div className="left-connector" />

        <div className="step-number">{isFinished || isOrderCompleted ? <CheckIcon /> : id + 1}</div>

        <div className="right-connector" />
      </div>
      <Translation id={`SHOP_STEP_TYPE/${step}`} />
    </div>
  )
}

export default ProgressBar
